import Modal from "react-bootstrap/Modal";
import DatePicker from "react-date-picker";
import Button from "react-bootstrap/Button";
import React from "react";
import InscriptionInput from "./InscriptionInput";


export default class ModalDateCorrection extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      validationCollector:[]
    }
  }

  collectValidations = (field, isValid) => {
    this.setState({
      validationCollector: this.state.validationCollector.filter(function (fieldList) {
        return fieldList !== field
      })
    }, () => {
      if (!isValid) {
        this.setState(prevState => ({
          validationCollector: [...prevState.validationCollector, field]
        }))
      }
    });
  }

  isValid = () => {
    if (this.props.withContactInfo) {
      return this.state.validationCollector.length === 0 && this.props.contactName && this.props.contactPhone
    }
    return true;
  }


  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.handleClose} dialogClassName="modal-40w">
        <Modal.Header closeButton>
          <Modal.Title>Confirmación de fecha de nacimiento del aspirante</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>La información registrada a continuación será enviada al correo del Colegio, para que se pueda estudiar el caso, por favor estar pendiente de la comunicación en donde le indicarán como proceder </label><br />
          <hr />
          <label>Fecha de nacimiento del aspirante</label><br />
          <DatePicker
            onChange={this.props.onChange}
            value={this.props.date}
            maxDate={new Date()}
          />
          {this.props.withContactInfo?
            <>
              <br />
              <InscriptionInput value={this.props.contactPhone}
                label="Teléfono de contacto acudiente principal"
                validation="number"
                name="contactPhone"
                handleChange={this.props.onChangeContact}
                collectValidations={this.collectValidations}
                />
              <InscriptionInput value={this.props.contactName}
                validation="text"
                name="contactName"
                label="Nombre de contacto acudiente principal"
                handleChange={this.props.onChangeContact}
                collectValidations={this.collectValidations}
              />
            </>:<></>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={this.props.callBack} disabled={!this.isValid()}>
            Enviar
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


